import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { dateFormat } from 'app/appSettings'
import moment from 'moment'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

/**
 * Props for the FormDatePickerPdf component
 * @interface FormDatePickerPdfProps
 */
export interface FormDatePickerPdfProps {
  /** The date value to display */
  value?: moment.Moment | null
}

const styles = StyleSheet.create({
  date: {
    fontSize: pdfDefaultFontSize
  }
})

/**
 * Component that renders a date picker in PDF format
 * @component
 * @category Form Components
 * @subcategory PDF Renderers
 * @function FormDatePickerPdf
 * @param {FormDatePickerPdfProps} props - Component props
 * @returns {React.ReactElement} A View component containing the formatted date
 */
export const FormDatePickerPdf: React.FC<FormDatePickerPdfProps> = ({
  value
}: FormDatePickerPdfProps): React.ReactElement => {
  const displayValue = (value !== undefined && value !== null)
    ? moment.utc(value).format(dateFormat)
    : ''

  return (
    <View>
      <Text style={styles.date}>
        {displayValue}
      </Text>
    </View>
  )
}
